import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";

// Components
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ChatBot from "./components/ChatBot";
import CookieConsent from "./components/CookieConsent";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MembershipsPage from "./pages/MembershipsPage";
import ServicesPage from "./pages/ServicesPage";
import ResourcesPage from "./pages/ResourcesPage";
import ResourcePostPage from "./pages/ResourcePostPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";
import AdminPage from "./pages/AdminPage";

// Remove any external badges
const useBadgeRemover = () => {
  useEffect(() => {
    const removeBadge = () => {
      // Remove iframes without proper src (potential badge containers)
      document.querySelectorAll('body > iframe').forEach(iframe => {
        if (!iframe.src || iframe.src === '' || iframe.src.includes('emergent')) {
          iframe.remove();
        }
      });
      // Remove fixed position elements outside #root that might be badges
      document.querySelectorAll('body > *:not(#root):not(script):not(noscript)').forEach(el => {
        const style = window.getComputedStyle(el);
        if (style.position === 'fixed') {
          el.style.display = 'none';
        }
      });
    };
    
    // Run immediately and after a delay (for dynamically injected content)
    removeBadge();
    const timeouts = [100, 500, 1000, 2000].map(ms => setTimeout(removeBadge, ms));
    
    // Also observe for new elements
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: false });
    
    return () => {
      timeouts.forEach(clearTimeout);
      observer.disconnect();
    };
  }, []);
};

function App() {
  useBadgeRemover();
  
  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-[#1E3A8A] focus:text-white focus:px-4 focus:py-2 focus:rounded-md focus:font-bold">
          Skip to main content
        </a>
        <ScrollToTop />
        <Routes>
          {/* Admin route without nav/footer */}
          <Route path="/admin" element={<AdminPage />} />
          
          {/* Public routes with nav/footer */}
          <Route path="/*" element={
            <>
              <Navigation />
              <main id="main-content" role="main">
                <Routes>
                  <Route index element={<HomePage />} />
                  <Route path="about" element={<AboutPage />} />
                  <Route path="memberships" element={<MembershipsPage />} />
                  <Route path="services" element={<ServicesPage />} />
                  <Route path="resources" element={<ResourcesPage />} />
                  <Route path="resources/:slug" element={<ResourcePostPage />} />
                  <Route path="contact" element={<ContactPage />} />
                  <Route path="privacy" element={<PrivacyPage />} />
                </Routes>
              </main>
              <Footer />
              <ChatBot />
              <CookieConsent />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
